module.exports = __webpack_public_path__ + "static/media/icon_80.77b38a32.svg";